/**
 * Auth-derived values (`profileId`, sign-out/switch-user) that
 * {@link AuthenticatedWorkspace} needs but cannot receive as ordinary React
 * props once it's rendered by the router: `EntraSessionGate` builds the
 * router once, outside the auth lifecycle, so these are threaded through
 * context instead, wrapping `<RouterProvider>`.
 *
 * @module components/shell/auth-shell-context
 */

import React, { useContext } from "react";

export interface AuthShellValue {
  profileId: string;
  onLogout: () => void;
  onSwitchUser: () => void;
}

const AuthShellContext = React.createContext<AuthShellValue | null>(null);

export function AuthShellProvider({
  value,
  children,
}: {
  value: AuthShellValue;
  children: React.ReactNode;
}) {
  return <AuthShellContext.Provider value={value}>{children}</AuthShellContext.Provider>;
}

export function useAuthShell(): AuthShellValue {
  const value = useContext(AuthShellContext);
  if (!value) {
    throw new Error("useAuthShell must be used within an AuthShellProvider");
  }
  return value;
}
